import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'
import Icon from 'material-ui/Icon'

import { ModalHeader, ModalContents, ModalFooter } from '../../common/modal'

import { validateFormData } from '../../../common/formtool'

class EmailReport extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      recipients: {
        emails: []
      },
      addresses: '',
      errors: {}
    }
    this.onChange = this.onChange.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onChange (e) {
    this.setState({ addresses: e.target.value })
  }

  handleClose (e) {
    this.props.close()
  }

  handleSubmit () {
    let { translate } = this.props
    let { addresses } = this.state
    let recipients = []
    let emails = addresses.split(';')

    if (!addresses.length) {
      const errors = translate('formfield_error_general_required')
      this.setState({ errors })
    } else {
      let errors = validateFormData(emails, {
        required: translate('formfield_error_general_required'),
        validEmail: translate('formfield_error_general_email')
      })
      if (Object.keys(errors).length) {
        this.setState({ errors: errors })
      } else {
        recipients = emails.map(email => email.trim())
        this.props.submit({ recipients })
      }
    }
  }

  render () {
    const { translate, classes } = this.props

    const { addresses, errors } = this.state

    return (
      <Modal open onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type='headline'
                color='inherit'
                className={classes.modalHeader}
              >
                {translate('send_report_title')}
              </Typography>

              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete='off' className={classes.form}>
                <TextField
                  required
                  error={typeof errors === 'string'}
                  name='serialnumber'
                  label={translate('email_addressess')}
                  margin='normal'
                  fullWidth
                  value={addresses}
                  onChange={this.onChange}
                  helperText={
                    errors.serialnumber
                      ? errors.serialnumber
                      : translate('email_addressess_help')
                  }
                />
                {/* <span className={classes.error}>{typeof (errors) === 'string' && errors}</span> */}
              </form>
            </ModalContents>
            <ModalFooter>

              <Button
                raised
                color='primary'
                className={classes.submit}
                onClick={this.handleSubmit}
                type='submit'
              >
                {translate('general_submit')}
              </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}
export default withStyles(styles)(EmailReport)
